import {
  isNotAssignedPickup,
  isNotCompletedPickup,
  isCompletedPickup,
  isMissedPickup,
  isFuturePickup,
} from '../../filterUtils';
import type { TrailerMoveFilterOption } from '../types';

export const TRAILER_MOVES_GRID_FILTERS = {
  all: 'allTrailerMoves',
  unassigned: 'unassigned',
  assigned: 'assigned',
  future: 'future',
  missed: 'missed',
  completed: 'completed',
  voided: 'voided',
};

export const TRAILER_MOVES_PANEL_FILTERS = {
  all: 'all',
  swaps: 'swaps',
  drops: 'drops',
  hooks: 'hooks',
  spottedTrailers: 'spottedTrailers',
};

export const TRAILER_MOVES_FILTER_LIST: TrailerMoveFilterOption[] = [
  {
    label: 'All Trailer Moves',
    value: TRAILER_MOVES_GRID_FILTERS.all,
    filterFunc: () => true,
  },
  {
    label: 'Unassigned',
    value: TRAILER_MOVES_GRID_FILTERS.unassigned,
    filterFunc: ({ pickup, terminalOffset }) => isNotAssignedPickup({ pickup, terminalOffset }),
  },
  {
    label: 'Assigned',
    value: TRAILER_MOVES_GRID_FILTERS.assigned,
    filterFunc: ({ pickup, terminalOffset }) => isNotCompletedPickup({ pickup, terminalOffset }),
  },
  {
    label: 'Future',
    value: TRAILER_MOVES_GRID_FILTERS.future,
    filterFunc: ({ pickup, terminalOffset }) =>
      isFuturePickup(pickup.pickupDate as string, terminalOffset) && !pickup.isVoided,
  },
  {
    label: 'Missed',
    value: TRAILER_MOVES_GRID_FILTERS.missed,
    filterFunc: ({ pickup }) => isMissedPickup({ pickup }),
  },
  {
    label: 'Completed',
    value: TRAILER_MOVES_GRID_FILTERS.completed,
    filterFunc: ({ pickup, terminalOffset }) => isCompletedPickup({ pickup, terminalOffset }),
  },
  {
    label: 'Voided',
    value: TRAILER_MOVES_GRID_FILTERS.voided,
    filterFunc: ({ pickup }) => Boolean(pickup.isVoided),
  },
];

export const DEFAULT_TRAILER_MOVES_FILTER = TRAILER_MOVES_FILTER_LIST.find(
  (filter) => filter.value === TRAILER_MOVES_GRID_FILTERS.unassigned
) as TrailerMoveFilterOption;
